import ReactGA from 'react-ga'
import React from 'react'
import 'core-js/fn/object/assign'
import { Provider } from 'react-redux'
import { OidcProvider } from 'redux-oidc'
import { I18nextProvider } from 'react-i18next'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import store, { persistor } from './store'
import Routes from './routes'

import i18n from './utils/i18n'
import userManager from './utils/PHZUserManager'
import { MuiThemeProvider } from '@material-ui/core/styles'
import theme from './styles/customTheme'
import { PersistGate } from 'redux-persist/integration/react'
import { Loading } from './utils/loading.utils'
import CacheBuster from './CacheBuster'
import { NavigationPromptProvider } from './NavigationPromptProvider'
//import { validateToken } from './actions'

// for older browsers
//require('@babel/polyfill')
require('es6-promise').polyfill()

//Google Analytics Tracking Code
ReactGA.initialize('UA-129495772-1')
/* ReactGA.pageview('/')
ReactGA.pageview('hinnasto')
ReactGA.pageview('faq')
ReactGA.pageview('yrityksille')
ReactGA.pageview('yhteystiedot') */
ReactGA.pageview('/kiitos-rekisteroitymisesta')
// ReactGA.pageview('/dashboard/login')

export default class RootComponent extends React.Component {
  render() {
    return (
      <Provider store={store}>
        <MuiThemeProvider theme={theme}>
          <OidcProvider store={store} userManager={userManager}>
            <I18nextProvider i18n={i18n}>
              <PersistGate persistor={persistor} loading={<Loading />}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <CacheBuster>
                    {({ loading, isLatestVersion, refreshCacheAndReload }) => {
                      if (loading) return null
                      if (!loading && !isLatestVersion) {
                        refreshCacheAndReload()
                      }
                      return <div></div>
                    }}
                  </CacheBuster>
                  <NavigationPromptProvider>
                    <Routes />
                  </NavigationPromptProvider>
                </MuiPickersUtilsProvider>
              </PersistGate>
            </I18nextProvider>
          </OidcProvider>
        </MuiThemeProvider>
      </Provider>
    )
  }
}
